"use client";

import Script from 'next/script';

const Cookiehub = () => {
  // Komponent będzie renderowany tylko w środowisku produkcyjnym
  if (process.env.NODE_ENV !== "production") {
    return null;
  }

  return (
    <Script
      id="cookiehub-script"
      src="https://cdn.cookiehub.eu/c2/2c9433e8.js"
      strategy="afterInteractive"
      onReady={() => {
        // Funkcja 'onReady' uruchamia się natychmiast po załadowaniu skryptu.
        // To jest nowoczesny odpowiednik `DOMContentLoaded` dla skryptów w Next.js,
        // który gwarantuje, że `window.cookiehub` na pewno istnieje.
        if (window.cookiehub) {
          var cpm = {};
          window.cookiehub.load(cpm);
        }
      }}
    />
  );
};

export default Cookiehub;